import { SnLprV3FlockRead } from '../models/lpr-flock-v3-read';

/**
 * Interface used for mapping of results returned by the API for Flock V3.
 * @url https://docs.flocksafety.com/developer-hub/reference/post_reads-lookup-1
 */
export interface FlockV3LprResults {
  links: {
    next: string;
    previous: string;
  };
  results: SnLprV3FlockRead[];
  messages: string[];
  resultCount: number;
}
